import * as React from "react";

import style from "@/views/FoodStore/FoodStore.module.scss"

interface ReadMoreProps {
  text: string;
  maxChars?: number;
  viewMoreTitle?: string;
  viewLessTitle?: string;
}

const ReadMoreString: React.FC<ReadMoreProps> = ({
  text,
  maxChars = 100,
  viewMoreTitle = "Read more",
  viewLessTitle = "Read less",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (text.length <= maxChars) return <p>{text}</p>;

  const toggleText = () => { setIsExpanded((prev) => !prev); };

  return (
    <p>
      {isExpanded ? (
        text
      ) : (
        <>
          {text.slice(0, maxChars)}
          <span aria-hidden="true">…</span>
        </>
      )}
      <button
        onClick={toggleText}
        aria-expanded={isExpanded}
        className={style.ReadMore}
      >
        {isExpanded ? viewLessTitle : viewMoreTitle}
      </button>
    </p>
  );
};

export default ReadMoreString;
